<template>
    <div>
        <navbar1></navbar1>
        <div class="__outsourcebg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 col-md-9 col-sm-9">
                        <!-- <p class="__welf1">Outsource your engineering team with us</p> -->
                        <p class="__welf1">Hire from our network<br> of pre-vetted tech talents</p>
                        <p class="__welf2">Fill the form below and we will reach you shortly</p>
                    </div>
                    <div class="col-lg-5 col-md-3 col-sm-3"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="__form-wrap ">
                <div class="row ">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <p class="__number">
                        10,000+
                        </p>
                        <p>
                        Active members in the <br />
                        saucecode community.
                        </p>

                        <p class="__number">
                        510+
                        </p>
                        <p>
                        Number of professionals in <br />
                        our PRO network.
                        </p>

                        <p class="__number">
                        120+
                        </p>
                        <p>
                        Number of hired developers <br />
                        and designers.
                        </p>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8">
                        <p class="__hirep">
                        Let us know you
                        </p>

                        <p class="__hirep1">We charge 10% of the talent’s annual salary only.</p>
                        <!-- <p class="__hirep1">We charge N30,000 i.e $83 as commitment fee and 10% of the talent’s annual salary.</p> -->

                        <form @submit.prevent="processForm()" method="POST" enctype="multipart/form-data">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="full-name">Full name</label>

                                        <input
                                        autofocus
                                        type="text"
                                        class="form-control __form-control"
                                        id="full-name"
                                        name="full-name"
                                        data-field="general"
										v-model="formField.fullName"
                                        placeholder="John Jane Doe"
										required="required"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="email">Email</label>

                                        <input
                                        type="email"
                                        class="form-control __form-control"
                                        id="email"
                                        name="email"
                                        data-field="email"
										v-model="formField.email"
                                        placeholder="address@yourdomain.com"
										required="required"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="phone">Phone number</label>
                                        <input
                                        type="tel"
                                        class="form-control __form-control"
                                        id="phone"
                                        name="phone"
                                        data-field="phone"
										v-model="formField.phone"
                                        placeholder="+234 810 544 8756"
										required="required"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
									<div class="form-group">
                                        <label for="company-loc">Company location</label>
										<select v-model="formField.location" name="location" id="location" class="form-control __form-control" required="required">
											<option value="location" disabled>Location</option>
											<option value="on-site">On-site</option>
											<option value="remote">Remote</option>
										</select>
									</div>
                                    
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
										<label for="salary-range">Talent (UI/UX, project-manager e.t.c)</label>
										<input type="text" v-model="formField.talent" name="talent" placeholder=" " class="form-control __form-control" required>
									</div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="day-amt">Days per week</label>

                                        <select
                                        class="form-control __form-control"
                                        id="day-amt"
                                        name="day-amt"
                                        data-field="general"
										v-model="formField.daysaweek"
                                        >
                                            <option value="">Enter Days per week</option>
                                            <option value="1">1 day</option>
                                            <option value="2">2 day</option>
                                            <option value="3">3 day</option>
                                            <option value="4">4 day</option>
                                            <option value="5">5 day</option>
                                            <option value="6">6 day</option>
                                            <option value="7">7 day</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            
							
							<div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="work-dur">Week Duration</label>

                                        <input
                                        type="number"
                                        class="form-control __form-control"
                                        id="work-dur"
                                        name="work-dur"
                                        data-field="general"
										v-model="formField.duration"
                                        placeholder="Enter duration"
										required="required"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
										<label for="salary-range">Duration</label>
										<select v-model="formField.durationLabel" name="durationLabel" id="" class="form-control __form-control" required="required">
											<option value="duration" disabled>Duration</option>
											<option value="weeks">Weeks</option>
											<option value="months">Months</option>
										</select>
									</div>
                                </div>
                            </div>
							
							
							<div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
										<label for="salary-range">Job (Job description)</label>
										<input type="text" v-model="formField.job" name="job" placeholder=" " class="form-control __form-control" required>
									</div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
										<label for="salary-range">Job location </label>
										<textarea v-model="formField.joblocate" name="joblocate" id="job-location" class="form-control __form-control" rows="3" placeholder="Job location (city where the job is at)" required="required"></textarea>
									</div>
                                </div>
                            </div>
							

                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="form-group">
                                    <label for="salary-range">Salary range</label>

                                    <input
                                    type="text"
                                    class="form-control __form-control"
                                    id="salary-range"
                                    name="salary-range"
                                    data-field="general"
                                    placeholder="N 000,000.00"
									v-model="formField.salary"
									required
                                    />
                                </div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="form-group">
                                    <label for="resumption"
                                    >Resumption (When do you want the talent to resume)</label
                                    >

                                    <input
                                    type="date"
                                    class="form-control __form-control"
                                    id="resumption"
                                    name="resumption"
                                    data-field="general"
                                    placeholder="Enter Date"
									v-model="formField.resumption"
									required
                                    />
                                </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
									<div class="form-group">
										<label for="work-time">Part time or full time</label>

										<div class="__radio-wrap">
											<div class="radio">
												<label class="cust-label no-top">
												<input
													data-radio="work-time"                         
													type="radio"
													name="type"
													value="part-time"
													v-model="formField.type"
												/>Part time
												<span class="checkmark"></span>
												</label>
											</div>
											<div class="radio">
												<label class="cust-label">
												<input
													type="radio"
													name="type"
													value="full-time"
													v-model="formField.type"
												/>Full time
												<span class="checkmark"></span>
												</label>
											</div>
											<!-- <div class="radio">
												<label class="cust-label">
												<input
													type="radio"
													name="work-time"
													value="on-site"
												/>On site
												<span class="checkmark"></span>
												</label>
											</div>
											<div class="radio">
												<label class="cust-label">
												<input
													type="radio"
													name="work-time"
													value="remote"
												/>Remote On
												<span class="checkmark"></span>
												</label>
											</div> -->

											<div class="radio">
												<label class="cust-label">
												<input
												
													type="radio"
													name="type"
													value="onsite-remote"
                                                    v-model="formField.type"
												/>On site with remote options
												<span class="checkmark"></span>
												</label>
											</div>
										</div>
									</div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
									<div class="form-group">
										<label for="work-time">Levels</label>

										<div class="__radio-wrap">
											<div class="radio">
												<label class="cust-label no-top">
												<input
													data-radio="level"
													type="radio"
													name="level"
													value="beginner"
													v-model="formField.level"
												/>Beginner
												<span class="checkmark"></span>
												</label>
											</div>

											<div class="radio">
												<label class="cust-label">
												<input
													type="radio"
													name="level"
													value="intermediate"
													v-model="formField.level"
												/>Intermediate
												<span class="checkmark"></span>
												</label>
											</div>

											<div class="radio">
												<label class="cust-label">
												<input

													type="radio"
													name="level"
													value="expert"
													v-model="formField.level"
												/>Senior
												<span class="checkmark"></span>
												</label>
											</div>
										</div>
									</div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                <button class="btn btn-block  __adjustlink ">Submit form</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navbar1 from "../components/navbar1";

import axios from 'axios'
export default {
  components: { navbar1 },
  data () {
        return{
            formField: {
                fullName: null,
                email: null,
                phone: null,
                type: 'select',
                location: 'location',
                duration: null,
                durationLabel: 'duration',
                talent: null,
                job: null,
                joblocate: null,
                daysaweek: null,
                salary: null,
                resumption: null,
                level: 'level',
            },
            redirect: true   
        }
    },
  
 methods: {
        uploadFile(event){
            this.file = event.target.files[0]
        },
            processForm: function() {
                this.$validator.validateAll().then(() => {
                    if (! this.errors.any()) {
                        // Make the api call for form submission
                        this.makeFormRequest()
                    } else {
                        // Show form validation error toast
                        this.$toasted.global.form_validation_error()
                    }
                });
            },
            makeFormRequest: function () {
                let fd = new FormData();
                Object.keys(this.formField).forEach(key => fd.append(key, this.formField[key]));
                axios({
                    url:'https://cors-anywhere.herokuapp.com/' +  'http://18.212.187.249/findworka/talents/extend-team',
                    headers: {"Access-Control-Allow-Origin": "*"},
                    method: 'post',
                    
                    data: fd
                    })
                    .then((response) => {
                        console.log(response)
                        if (response.data.error == true) {
                            // Should redirect to list if redirect was checked
                            this.$toasted.show(response.data.message[0])
                        }else {
                            this.$toasted.show(response.data.message)
							this.$router.push({ name: 'payment' })
							// window.location.href = "http://siwei.me"
                        }
                            //Reset form
                    })
                    .catch(error => this.apiErrorCatcher(error))
                    .finally( () => this.resetForm())//clear form automatically after successful request
            },
            resetForm() {
                console.log('Reseting the form')
                var self = this; //you need this because *this* will refer to Object.keys below`

                //Iterate through each object field, key is name of the object field`
                Object.keys(this.formField).forEach(function(key,index) {
                self.formField[key] = '';
                });
		    }
    }
};
</script>

<style scoped>
@import '../assets/css/talent';


</style>



// WEBPACK FOOTER //
// src/components/talent.vue